import { Product } from '@la/types';
import { getRegistrationType } from '@la/utilities';
import { useRegistration } from 'lib/context/RegistrationContext/RegistrationContext';
import { useRegistrationAddOns } from 'redux/hooks/useRegistrationAddOns';
import AddOnCards from './AddOnCards';
import styles from './RegistrationAddOnsCard.module.scss';

export default function RegistrationAddOnsCard() {
  const { ctx } = useRegistration();
  const registrationType = getRegistrationType(ctx?.type);
  const {
    getRequiredStaffAddOns,
    getOptionalStaffAddOns,
    getRequiredPlayerAddOns,
    getOptionalPlayerAddOns,
  } = useRegistrationAddOns();
  let optionalAddons: Product[] = [];
  let requiredAddons: Product[] = [];

  if (registrationType === 'player') {
    optionalAddons = getOptionalPlayerAddOns();
    requiredAddons = getRequiredPlayerAddOns();
  } else if (registrationType === 'staff') {
    optionalAddons = getOptionalStaffAddOns();
    requiredAddons = getRequiredStaffAddOns();
  }

  return (
    <div className={styles.registrationAddOnsCard}>
      <AddOnCards
        optionalAddOns={optionalAddons}
        requiredAddOns={requiredAddons}
      />
    </div>
  );
}
